import { useIntl } from 'react-intl';

export default function CentriDiEccellenzaHead() {
  const intl = useIntl();
  return (
    <div className="snf-lx-components-centri-di-eccellenza-head" style={{ display: 'contents' }}>
      <>
        <div className="row m-0 wrapper w-100">
          <div className="col-12 col-md-10 offset-md-1">
            {/* <div className="row justify-content-end">
            <div className="col-auto ">
              <img className="img" alt="Logo regione" src="/images/logo-regione.png" />
            </div>
          </div> */}
            <div className="row">
              <div className="col-12 snf-font-32 snf-font-w6 mb-4">
                {intl.formatMessage({
                  defaultMessage: 'Rieti Innovation Center'
                })}
              </div>
            </div>
            <div className="row">
              <div className="col-12 snf-font-16 mb-3">
                {intl.formatMessage(
                  {
                    defaultMessage:
                      'Il polo <strong>Innovation Center di Rieti,</strong> co-finanziato dal Ministero dello Sviluppo Economico e dalla Regione Lazio, nasce nel 2019 dal progetto “<strong>Digital First</strong>” di Sistemi Informativi, per promuovere la <strong> trasformazione digitale</strong> e lo <strong> sviluppo di progetti innovativi</strong> di piccole e grandi aziende. Con la sua unità operativa, focalizzata sulla ricerca e lo sviluppo di soluzioni tecnologiche all’avanguardia, in collaborazione con la Sabina Universitas e con altre università regionali, contribuisce al <strong>rilancio occupazionale</strong> del territorio reatino, colpito dal terremoto nel 2016. Grazie a un investimento totale di circa 18 milioni di euro, di cui circa 5 milioni derivanti da fondi dell’Unione Europea, questa iniziativa si colloca come uno dei 16 centri di innovazione aperti da IBM in tutta Europa, come parte integrante di un progetto più ampio, volto a favorire la <strong> formazione di nuove professionalità</strong> e competenze sulle tecnologie emergenti. La squadra di Rieti è in continua crescita, il centro ha festeggiato i suoi primi cento professionisti e giovani talenti.'
                  },
                  {
                    strong: (chunks) => <strong>{chunks}</strong>
                  }
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
}
